import { currentCompany } from '../../actionTypes';

const initialState = {
  companyAdminInfo: {},
  loading: false,
  updating: false,
  success: false,
  error: false,
};

export default function companyAdminInfoReducer(state = initialState, action) {
  switch (action.type) {
    case currentCompany.companyAdminInfo.get.start:
      return { ...state, loading: true };

    case currentCompany.companyAdminInfo.get.end:
      return {
        ...state,
        loading: false,
        companyAdminInfo: action.payload[0].data,
      };
    case currentCompany.companyAdminInfo.get.error:
      return {
        ...state,
        loading: false,
        data: {},
      };
    case currentCompany.companyAdminInfo.update.start:
      return { ...state, updating: true };

    case currentCompany.companyAdminInfo.update.end:
      return {
        ...state,
        updating: false,
        data: { ...state.data, ...action.payload },
        success: true,
        error: false,
      };
    case currentCompany.companyAdminInfo.update.error:
      return {
        ...state,
        updating: false,
        success: false,
        error: true,
      };

    case currentCompany.companyAdminInfo.suspend.start:
      return { ...state, updating: true, success: false, error: false };

    case currentCompany.companyAdminInfo.suspend.end:
      return {
        ...state,
        updating: false,
        companyAdminInfo: { ...state.companyAdminInfo, ...action.payload },
        success: true,
        error: false,
      };

    case currentCompany.companyAdminInfo.suspend.error:
      return {
        ...state,
        updating: false,
        success: false,
        error: true,
      };

    case currentCompany.companyAdminInfo.reactivate.start:
      return { ...state, updating: true, success: false, error: false };

    case currentCompany.companyAdminInfo.reactivate.end:
      return {
        ...state,
        updating: false,
        companyAdminInfo: { ...state.companyAdminInfo, ...action.payload },
        success: true,
        error: false,
      };

    case currentCompany.companyAdminInfo.reactivate.error:
      return {
        ...state,
        updating: false,
        success: false,
        error: true,
      };

    default:
      return state;
  }
}
